<template>
  <common-dialog ref="dialog" title="需求统计 导出" width="1200px" @opened="onOpened" @closed="onClosed">
    <list
      row-key="Id"
      ref="list"
      unit="需求统计"
      :page="false"
      :query-params="params"
      :show-checkbox="false"
      :show-query="false"
      :get-data-func="getDataFunc"
    >
      <template slot="toolbar-left">
        <span style="line-height: 28px;margin-left: 10px;">
          <span>文件名称：</span>
          <span>{{fileName}}</span>
          <span>.xlsx</span>
        </span>
      </template>
      <template slot="toolbar-right">
        <el-button size="mini" type="primary" @click="exportExl()">确 定</el-button>
      </template>
      <template slot="table">
        <el-table-column prop="Name" :label="type==0?'科室名称':'月份'" />
        <el-table-column prop="Count" label="申请数量" />
        <el-table-column prop="PassCount" label="审核通过数量" />
        <el-table-column prop="DevelopCount" label="开发中数量" />
        <el-table-column prop="TestCount" label="测试中数量" />
        <el-table-column prop="CompleteCount" label="已完成数量" />
      </template>
    </list>
  </common-dialog>
</template>
<script>
import dialogMixins from "@/mixins/dialog";
import commonDialog from "@/components/common/dialog";
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [dialogMixins, listMixin],
  components: { commonDialog, list },
  data() {
    return {
      fileName: "",
      type: 0,
      autoWidth: true,
      bookType: "xlsx",
      params: {},
      api: require("@/api/bm/requirement").default,
    };
  },
  methods: {
    onOpened(data) {
      console.log("onOpened", JSON.parse(JSON.stringify(data)));
      this.fileName = data.fileName;
      this.type = data.type;
    },
    exportExl() {
      // if (this.fileName == "" || this.fileName == null) {
      //   this.$message.warning("请输入要保存的文件名称");
      //   return;
      // }
      let exportData = this.$refs.list.$refs.table.data;
      if (exportData.length == 0) {
        this.$message.warning("数据为空，无法导出");
        return;
      }
      var name = this.type == 0 ? "科室名称" : "月份";
      // console.log("exportExl", name);
      const loading = this.$loading({
        lock: true,
        text: "Loading...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      import("@/vendor/Export2Excel").then((excel) => {
        const tHeader = [
          name,
          "申请数量",
          "审核通过数量",
          "开发中数量",
          "测试中数量",
          "已完成数量",
        ];
        const filterVal = [
          "Name",
          "Count",
          "PassCount",
          "DevelopCount",
          "TestCount",
          "CompleteCount",
        ];
        const data = this.formatJson(filterVal, exportData);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.fileName,
          autoWidth: this.autoWidth,
          bookType: this.bookType,
        });
        loading.close();
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          // if (j === "AddTime") {
          //   return this.$commonJs.toDateString(v[j]);
          // } else {
          //   return v[j];
          // }
          return v[j];
        })
      );
    },
    // getData() {
    //   console.log("this.$refs.list.getData");
    //   this.$nextTick(() => {
    //     this.$refs.list.getData();
    //   });
    // },
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.getStat(params).then((res) => {
          var sum_row = {
            Name: "合计",
            CompleteCount: res.Data.map((x) => x.CompleteCount).reduce(getSum),
            Count: res.Data.map((x) => x.Count).reduce(getSum),
            DevelopCount: res.Data.map((x) => x.DevelopCount).reduce(getSum),
            PassCount: res.Data.map((x) => x.PassCount).reduce(getSum),
            TestCount: res.Data.map((x) => x.TestCount).reduce(getSum),
          };
          function getSum(total, num) {
            return total + num;
          }
          // console.log("sum_row", sum_row);
          res.Data.push(sum_row);
          resolve(res);
        });
      });
    },
    onClosed() {
      this.fileName = "";
      this.type = 0;
    },
  },
};
</script>